import { useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";

// components
import {
	NewPassword,
	ResetPassword,
	ResetPasswordError,
	ResetPasswordPending,
	ResetPasswordSuccess
} from "./ResetPassword/ResetPassword";

// hooks and utilities
import { useLanguage, useTranslateFunction } from "lang/Translate";

// common components
import SlidingTextButton from "components/common/SlidingTextButton/SlidingTextButton";

// api
import api from "api/api";

// styles
import "./VerifyEmail.scoped.scss";
import BallGridPulseLoader from "components/common/BallGridPulseLoader/BallGridPulseLoader";

const VerifyEmail = () => {
	const [pending, setPending] = useState(false);

	const translate = useTranslateFunction("Verification");
	const history = useHistory();

	const searchParams = new URLSearchParams(window.location.search);
	const type = searchParams.get("type");

	function beforeLeave() {
		const searchParams = new URLSearchParams(window.location.search);
		searchParams.delete("type");
		searchParams.delete("email");
		searchParams.delete("resend");

		const l = window.location;
		const newUrl = l.origin + l.pathname + "?" + searchParams.toString() + l.hash;

		window.history.pushState({}, "", newUrl);
		history.push("/");
	}

	return (
		<div className="background">
			<div className="container">
				{pending && <BallGridPulseLoader color="hsla(215, 50%, 23%, 1)" />}

				<div className={pending ? "hide" : ""}>
					{type === "pending" && <Pending email={searchParams.get("email")} resend={searchParams.get("resend")} />}
					{type === "success" && <Success />}
					{type === "failed" && <Failed />}
					{type === "error" && <Error />}

					{/* Password reset related */}
					{type === "resetPassword" && <ResetPassword {...{ setPending }} />}
					{type === "newPassword" && <NewPassword {...{ setPending }} />}
					{type === "resetPasswordError" && <ResetPasswordError />}
					{type === "resetPasswordPending" && <ResetPasswordPending />}
					{type === "resetPasswordSuccess" && <ResetPasswordSuccess />}

					<SlidingTextButton
						icon={<i className="fas fa-arrow-rotate-left" />}
						text={translate("BUTTON")}
						background="darkBlue"
						onClick={beforeLeave}
					/>
				</div>
			</div>
		</div>
	);
};

const Success = () => {
	const translate = useTranslateFunction("Verification");

	return (
		<>
			<h2 style={{ color: "hsl(168, 97%, 31%)" }}>{translate("SUCCESS_HEADER")}</h2>
			<p style={{ color: "hsl(168, 97%, 24%)" }}>{translate("SUCCESS_CONTENT")}</p>
		</>
	);
};

const Failed = () => {
	const translate = useTranslateFunction("Verification");

	return (
		<>
			<h2 style={{ color: "hsl(348, 100%, 32%)" }}>{translate("FAILED_HEADER")}</h2>
			<p style={{ color: "hsl(348, 100%, 27%)" }}>{translate("FAILED_CONTENT")}</p>
		</>
	);
};

const Error = () => {
	const translate = useTranslateFunction("Verification");

	return (
		<>
			<h2 style={{ color: "hsl(348, 100%, 32%)" }}>{translate("ERROR_HEADER")}</h2>
			<p style={{ color: "hsl(348, 100%, 27%)" }}>
				{translate("ERROR_CONTENT")}{" "}
				<u>
					<b>
						<a href="mailto: bugsagm@wiktorgolicz.pl">bugsAGM@wiktorgolicz.pl</a>
					</b>
				</u>
				.
			</p>
		</>
	);
};

const Pending = ({ email, resend }) => {
	const translate = useTranslateFunction("Verification");
	const lang = useLanguage();

	async function resendEmail() {
		const searchParams = new URLSearchParams(window.location.search);
		try {
			await axios.patch(`${api}/auth/verify`, { email, lang });
			searchParams.delete("resend");
		} catch (err) {
			console.error(err);
			searchParams.set("type", "error");
		}

		// window.location.search = searchParams.toString();
	}

	return (
		<>
			<h2>{translate("PENDING_HEADER")}</h2>
			<p>
				{translate("PENDING_CONTENT").split("%")[0]} <b>{email}</b>
				{translate("PENDING_CONTENT").split("%")[1]}
			</p>

			{resend === "true" && (
				<SlidingTextButton
					icon={<i className="fas fa-envelope" />}
					text={translate("RESEND_BUTTON")}
					background="darkBlue"
					onClick={resendEmail}
				/>
			)}

			{resend === "true" && <br />}
		</>
	);
};

export default VerifyEmail;
